import { Box, Container, makeStyles } from "@material-ui/core";

import { useBreakpoint } from "../../../../hooks/useBreakpoint";
import { SolarReport } from "../../../../api/Quote/SolarReport";
import { NumericFormat } from "react-number-format";

export const EnvironmentalImpact = ({ solarReportData }: { solarReportData: SolarReport | null }) => {
  const classes = useEnvironmentalImpactStyles();
  const { isMoreThanMd, isMoreThanSm } = useBreakpoint();
  return (
    <Box position={"relative"}>
      <Container maxWidth="lg">
        <Box className={classes.box}>
          <Box className={classes.boxClipPath}>
            <Box
              className={classes.boxContent}
              p={isMoreThanMd ? "60px 100px 90px 100px" : isMoreThanSm ? "60px" : "50px 26px 77px 26px"}
            >
              <Box
                fontSize={isMoreThanSm ? "28px" : "20px"}
                fontWeight={500}
                lineHeight={1.32}
                letterSpacing={isMoreThanSm ? "1.4px" : "0.5px"}
                color={"#fff"}
                textAlign={"center"}
              >
                The{" "}
                <Box component={"span"} color={"#f7815c"}>
                  environmental impact
                </Box>{" "}
                {!isMoreThanSm && <br />} of your {isMoreThanSm && <br />} Solar PV system is:
              </Box>
              <Box
                mt={isMoreThanSm ? "70px" : "31px"}
                display={"flex"}
                flexDirection={isMoreThanMd ? "row" : "column"}
                justifyContent={"center"}
                alignItems={"start"}
                maxWidth={"740px"}
                margin={"0 auto"}
              >
                <Box
                  display={"flex"}
                  flexDirection={isMoreThanMd ? "column" : "row"}
                  alignItems={isMoreThanMd ? "center" : "start"}
                  justifyContent={"center"}
                >
                  <img
                    src="images/quote/env_co2.svg"
                    alt="Over 25 years you will reduce your CO2 emissions by a massive"
                    width={isMoreThanSm ? "96px" : "70px"}
                    height={isMoreThanSm ? "95px" : "70px"}
                  />
                  <Box display={"flex"} flexDirection={"column"} ml={isMoreThanMd ? 0 : "33px"}>
                    <Box
                      mt={isMoreThanMd ? "42px" : 0}
                      fontSize={isMoreThanSm ? "16px" : "12px"}
                      fontWeight={400}
                      lineHeight={1.13}
                      color={"#fff"}
                      textAlign={isMoreThanMd ? "center" : "left"}
                    >
                      Over 25 years you will reduce your CO2 emissions by a massive
                    </Box>
                    <Box
                      mt={"16px"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={isMoreThanMd ? "center" : "start"}
                      textAlign={isMoreThanMd ? "center" : "left"}
                      fontSize={isMoreThanSm ? "28px" : "20px"}
                      fontWeight={400}
                      lineHeight={0.86}
                      color={"#fff"}
                    >
                      <img
                        src="images/quote/arrow_down.svg"
                        alt="arrow_down"
                        style={{ marginRight: "11px" }}
                        width={isMoreThanSm ? "14px" : "14px"}
                        height={isMoreThanSm ? "20px" : "18px"}
                      />{" "}
                      <NumericFormat
                        value={(solarReportData?.carbonReductionLifetimeKg || 0) / 1000}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={0}
                        suffix=" tonnes CO2"
                      />
                    </Box>
                  </Box>
                </Box>
                <Box
                  mt={isMoreThanMd ? 0 : "57px"}
                  display={"flex"}
                  flexDirection={isMoreThanMd ? "column" : "row"}
                  alignItems={isMoreThanMd ? "center" : "start"}
                  justifyContent={"center"}
                >
                  <img
                    src="images/quote/env_electricity.svg"
                    alt="Over 25 years the total production of renewable electricity from your system will be"
                    width={isMoreThanSm ? "96px" : "70px"}
                    height={isMoreThanSm ? "95px" : "70px"}
                  />
                  <Box display={"flex"} flexDirection={"column"} ml={isMoreThanMd ? 0 : "33px"}>
                    <Box
                      mt={isMoreThanMd ? "42px" : 0}
                      fontSize={isMoreThanSm ? "16px" : "12px"}
                      fontWeight={400}
                      lineHeight={1.13}
                      color={"#fff"}
                      textAlign={isMoreThanMd ? "center" : "left"}
                    >
                      Over 25 years the total production of renewable electricity from your system will be
                    </Box>
                    <Box
                      mt={"16px"}
                      display={"flex"}
                      alignItems={"center"}
                      justifyContent={isMoreThanMd ? "center" : "start"}
                      textAlign={isMoreThanMd ? "center" : "left"}
                      fontSize={isMoreThanSm ? "28px" : "20px"}
                      fontWeight={400}
                      lineHeight={0.86}
                      color={"#fff"}
                    >
                      <img
                        src="images/quote/arrow_up.svg"
                        alt="arrow_up"
                        style={{ marginRight: "11px", marginBottom: "8px" }}
                        width={isMoreThanSm ? "14px" : "14px"}
                        height={isMoreThanSm ? "20px" : "18px"}
                      />{" "}
                      <NumericFormat
                        value={(solarReportData?.productionAnnualKwh || 0) * 25}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalScale={0}
                        suffix=" kWh"
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box
                mt={isMoreThanSm ? "76px" : "68px"}
                fontSize={isMoreThanSm ? "17px" : "14px"}
                fontWeight={isMoreThanSm ? 600 : 500}
                lineHeight={isMoreThanSm ? 1.06 : 1.29}
                color={"#fff"}
                textAlign={"center"}
              >
                This is the equivalent of planting
              </Box>
              <Box
                mt={isMoreThanSm ? "30px" : "16px"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize={isMoreThanSm ? "50px" : "26px"}
                fontWeight={isMoreThanSm ? 400 : 500}
                lineHeight={isMoreThanSm ? 0.48 : 0.92}
                color={"#f7815c"}
                textAlign={"center"}
              >
                <img
                  src="images/quote/shape.svg"
                  alt="shape"
                  style={{ marginRight: "8px" }}
                  width={isMoreThanSm ? "26px" : "16px"}
                  height={isMoreThanSm ? "43px" : "27px"}
                />{" "}
                <NumericFormat
                  value={((solarReportData?.carbonReductionLifetimeKg || 0) / 1000) * 9.5}
                  displayType={"text"}
                  thousandSeparator={true}
                  decimalScale={0}
                  style={{ marginRight: "11px" }}
                  suffix=" trees"
                />{" "}
              </Box>
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const useEnvironmentalImpactStyles = makeStyles((theme) => ({
  box: {
    maxWidth: "1170px",
    width: "100%",
    minHeight: "706px",
    borderRadius: 4,
    position: "relative",
    margin: "0 auto",
    filter: "drop-shadow(0px 5px 5px rgba(0, 0, 0, 0.07)) drop-shadow(0px 10px 15px rgba(50, 50, 93, 0.1))",

    [theme.breakpoints.down(600)]: {
      minHeight: "575px"
    }
  },
  boxClipPath: {
    maxWidth: "1170px",
    width: "100%",
    minHeight: "706px",
    filter: "url(#round)",

    [theme.breakpoints.down(600)]: {
      minHeight: "575px"
    }
  },
  boxContent: {
    maxWidth: "1170px",
    width: "100%",
    minHeight: "706px",
    background: "#160337",
    clipPath: "polygon(calc(100% - 90px) 0, calc(100% - 90px) 90px, 100% 90px, 100% 100%, 0 100%, 0 0)",
    [theme.breakpoints.down("sm")]: {
      clipPath: "polygon(calc(100% - 40px) 0, calc(100% - 40px) 40px, 100% 40px, 100% 100%, 0 100%, 0 0)"
    },
    [theme.breakpoints.down(600)]: {
      minHeight: "575px"
    }
  }
}));
